// Axios
import Axios from "./axios"

export const resendEmailVerification = (email) => {
    return new Promise((resolve, reject) => {
        const data = Axios.put(`/user/resendEmail`, email)
        setTimeout(() => resolve(data), 1000)
    })

}